import axios from 'axios';
import { api } from './api';

export interface RuleData {
  file: File;
  country: string;
}

export interface RuleLegal {
  id: number;
  name: string;
  legal_text: string;
  color: string;
}

export interface RuleListItem {
  id: string;
  checked: boolean;
  disabled: boolean;
  name: string;
  description: string;
  type: string;
  status: string;
  template?: string;
  created_at?: string;
  created_date: string;
  actions: string;
  legal: RuleLegal | null;
}

export interface RuleListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: RuleListItem[];
}

export interface RuleListParams {
  page?: number;
  page_size?: number;
  type?: string;
  status?: string;
  search?: string;
  ordering?: string;
}

export const rulesService = {
  
  getRulesList: async (params?: RuleListParams): Promise<RuleListResponse> => {
    try {
      const response = await api.get('/rules/list', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener lista de reglas:', error);
      
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.error || 'Error al comunicarse con el servidor');
      }
      
      throw new Error('Error inesperado al obtener la lista de reglas');
    }
  },
 
  saveRule: async (ruleData: RuleData): Promise<{ success: boolean; message: string }> => {
    try {
      const formData = new FormData();
      formData.append('file', ruleData.file);
      formData.append('country', ruleData.country);

      const response = await api.post('/rules', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al guardar regla:', error);
      
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          message: error.response?.data?.error || 'Error al comunicarse con el servidor'
        };
      }
      
      return {
        success: false,
        message: 'Error inesperado al guardar la regla'
      };
    }
  },

  exportRules: async (ruleIds?: (string | number)[], format: 'xlsx' | 'csv' = 'xlsx'): Promise<{ success: boolean; blob?: Blob; message?: string }> => {
    try {
      const body: Record<string, unknown> = { format };
      if (ruleIds && ruleIds.length > 0) {
        body.rule_ids = ruleIds;
      }

      const response = await api.post('/export-rules', body, { responseType: 'blob' });
      return { success: true, blob: response.data };
    } catch (error) {
      console.error('Error al solicitar exportación de reglas:', error);
      if (axios.isAxiosError(error)) {
        return { success: false, message: error.response?.data?.error || 'Error al solicitar exportación' };
      }
      return { success: false, message: 'Error inesperado al solicitar exportación' };
    }
  },

};
